namespace Solovis.InvDataSelectors.ReportSelectorDialog {

    export interface SelectReportMoreOptions {
        showClearButton?: boolean
    }

    /**
     *     
     * @param callback -  callback should have signature of callback(reportInfo).
     * @param moreOptions
     */
    export function selectReport(callback: (reportInfo: any) => void, moreOptions?: SelectReportMoreOptions): void {
        /// <summary>
        /// callback should have signature of callback(reportInfo).
        /// moreOptions can specify showClearButton: true to have null report has an option.
        /// </summary>

        var moreOptionsToUse = moreOptions ? moreOptions : {};

        // We will load report list and then give user interface for selecting the report.
        var pathForCurrentUserReports = "/Solovis/Reports/CurrentUserReports";
        var options = {};

        Solovis.Rpc.invokeAndWait("~/Rpc/DataSource/LoadDataSet",
            { path: pathForCurrentUserReports, options: options },
            function (response, success) {
                if (success) {
                    Solovis.InvDataSelectors.ReportSelectorDialog._showReportSelector(response.result.dataSet.reports, callback, moreOptionsToUse);
                }
            });
    };

    export function _showReportSelector(reports, callback: (reportInfo: any) => void, moreOptions?: SelectReportMoreOptions) {
        // NOTE: We should create a nicer interface for this later.         

        // Create a list of reports. When user clicks one of the reports use that as the selected report.
        var selectReportFormDiv = $("<div>").css("position", "relative").css("height", "100%").css("overflow", "hidden");

        dialog = null;

        var listContainer = $("<div>").appendTo(selectReportFormDiv).css("height", "100%").css("padding-top", "40px");
        
        var reportList = $("<ul>").addClass("stack-list").css("height", "100%").css("overflow", "scroll");
        reportList.appendTo(listContainer);

        var filterTextBox = $("<input>").appendTo(selectReportFormDiv).css("position", "absolute").css("top", "0").css("left", "0");

        var fillReportList = function () {
            reportList.html("");

            var filterText = filterTextBox.val();
            var filterTextLower = null;
            if (filterText) {
                filterTextLower = filterText.toLowerCase();
            }

            $(reports).each(function (i, reportInfo: any) {
                var reportItem = $("<li>").appendTo(reportList);

                var includeItem = false;
                if (filterTextLower) {
                    if (reportInfo.path) {
                        var pathLower = reportInfo.path.toLowerCase();
                        if (pathLower.indexOf(filterTextLower) != -1) {
                            includeItem = true;
                        }
                    }                    
                }
                else {
                    includeItem = true;
                }

                if (includeItem) {
                    var selectReportLink = $("<a>")
                        .text(reportInfo.path)
                        .click(function () {
                            callback(reportInfo);
                            dialog.close();
                        });

                    selectReportLink.appendTo(reportItem);
                }
            });
        };

        fillReportList();        

        $(filterTextBox).keyup(function () {            
            fillReportList();
        });

        var dialog = null;

        var buttons: Solovis.UI.DialogButtonOptions[] = [];

        if (moreOptions.showClearButton) {
            buttons.push({
                label: "Clear",
                click: function () {
                    callback(null);
                    dialog.close();
                }
            })
        }

        buttons.push({
            label: "Cancel",
            click: function () {
                dialog.close();
            }
        });

        let desiredWidth = Math.min($(window).width() * 0.9, 600);
        let desiredHeight = Math.min($(window).height() * 0.9, 500);

        dialog = new Solovis.UI.Dialog({
            container: selectReportFormDiv,

            title: "Select Report",
            autoOpen: true,
            center: true,
            modal: true,
            width: desiredWidth,
            height: desiredHeight,
            destroyOnClose: true,
            actions: ["Close"],

            buttons: buttons,

            activate: function () {
                $(filterTextBox).focus();
            }
        });
    }

}